import { API as yachts } from '../../module/yachts/api';
import AsyncAutocomplete from '../form/components/AsyncAutocomplete.component';
import { Grid, Typography } from '@mui/material';
import Divider from '../form/components/Divider.component';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { red } from '@mui/material/colors';

import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const YachtForm = ({
  api = yachts.select,
  required = true,
  disabled = false,
  hasDivider = true,
}) => {

  const { from, to } = useSelector((state) => state.year);

  const disable = useMemo(() => {
    const currentYear = dayjs.utc().year();
    const fromDate = from ? dayjs.utc(from) : null;
    const toDate = to ? dayjs.utc(to) : null;

    const isCurrentFrom =
      !!fromDate &&
      fromDate.isValid() &&
      fromDate.year() === currentYear &&
      fromDate.month() === 0 &&
      fromDate.date() === 1;
    const isCurrentTo =
      !!toDate &&
      toDate.isValid() &&
      toDate.year() === currentYear &&
      toDate.month() === 11 &&
      toDate.date() === 31;

    return !(isCurrentFrom && isCurrentTo);
  }, [from, to]);

  return (
    <Grid container>
      {hasDivider && (
        <Grid item xs={12}>
          <Divider label='Yacht' />
        </Grid>
      )}

      <Grid item xs={12}>
        <AsyncAutocomplete
          id='id_yacht'
          label='Yacht'
          name='id_yacht'
          required={required}
          api={api}
          disabled={disabled || disable}
        />
      </Grid>

      {disable && (
        <Grid item xs={12}>
          <Typography
            style={{
              marginTop: 10,
              color: red[700],
              fontWeight: 600,
            }}
          >
            Operation not allowed. Select the current season.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default YachtForm;
